import type { EditAreaTemplate } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { describeTemplateGeometry } from '../lib/describe-template-geometry';

interface EditAreaTemplateSummaryProps {
  readonly template: Pick<EditAreaTemplate, 'geometry' | 'measurementKind' | 'measurement'>;
}

/** 템플릿에 들어 있는 것 — 실측 종류·실측, 면별 인쇄 영역(mm), 사진만 받는 면. */
export const EditAreaTemplateSummary = ({
  template,
}: EditAreaTemplateSummaryProps): ReactElement => {
  const summary = describeTemplateGeometry(
    template.geometry,
    template.measurementKind,
    template.measurement,
  );
  return (
    <div className="space-y-0.5 text-xs text-muted-foreground">
      <p>{summary.measurement}</p>
      {summary.faces.map((face) => (
        <p key={face}>{face}</p>
      ))}
      {summary.photoOnlyFaces.length > 0 ? (
        <p>사진만: {summary.photoOnlyFaces.join(', ')}</p>
      ) : null}
    </div>
  );
};
